import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Lazy null-safe client; pages can detect missing config and show fallback content
export const supabase =
  url && publishableKey ? createClient(url, publishableKey) : null;

export const isSupabaseConfigured = () => Boolean(supabase);
